module.exports = __webpack_public_path__ + "static/media/tutorial-icon.dc74c404.svg";